window.addEventListener("DOMContentLoaded", function(event) {
    // $ = jQuery;
    $('.llp-contact-box_action').on('change',function(){
      $('.llp-contact-box_action').removeClass('activeForm'); // supp des classes activeForm sur tout les boutons
      $(this).addClass('activeForm'); // ajout de la classe activeForm sur le bouton cliqué
      $('#widgetcontact > div').hide(); // masque tous les simu
      var formName = $('option:selected', this).attr('value')
      var idSimu = 'widgetContact_' + formName;
      if( $("#" + idSimu).length == 0 ) {
        $('#widgetcontact').append($('<div id="' + idSimu + '"></div>'));
        switch(idSimu) {
          case "etrerappele": var utms = {'utm_form': 'contact', 'utm_content': 'etrerappele'};
          break;
          // case "location": var utms = {'utm_form': 'contact', 'utm_content': 'location'};
          // break;
          case "question": var utms = { 'utm_form': 'contact', 'utm_content': 'question' };
          break;
          case "webmaster": var utms = { 'utm_form': 'contact', 'utm_content': 'webmaster' };
          break;
          default: var utms = { 'utm_form': 'contact' }; // ne se produit jamais si tout va bien
        }
        simu.push(
          widgetLoader.load({
            "containerID": idSimu,
            "template": "/app/themes/slx-financement/widget-simu/html/contact_"+formName+".html",
            "css": "/app/themes/slx-financement/widget-simu/css/sfi_contact.css",
            "rules": "rules_contact",
            "rules_uri": null,
            "mail": "/app/themes/slx-financement/widget-simu/html/contact_mail_client.html",
            "utms": utms
        }));
        $("#" + idSimu).css('opacity', 0);
      $("#" + idSimu).animate({
        'opacity' : 1
      }, 500);
    } else {
      $("#" + idSimu).show()
      $("#" + idSimu).css('opacity', 0);
      $("#" + idSimu).animate({
        'opacity' : 1
      }, 500);
    }
  });
  $('.llp-contact-box_action').change();

  $('.sfi-contact-select').on('click', function() {
    $('#contact-box').trigger('click') ;
  });
});

var simu = [];
